/* MEHERAAN filter drawer
   Client-side filtering of the products on the collection page. Every option is derived from the real
   product data printed on each card by snippets/product-item.liquid:
     data-tw-tags   all product tags -> the filter groups defined as "Filter group" blocks in the theme editor
                    (each block: label, comma-separated tags, style list/chips/swatches, "Show more" limit)
     data-tw-sizes  "S:1|M:0|..." from the Size option, 1 = in stock
     data-tw-price  price in cents, data-tw-sale 1 when compare-at > price, data-tw-avail 1 when purchasable
   A group is shown only when a product on the page carries one of its tags. Selections are remembered per
   collection for the session and survive the theme's sort re-render. */
(function () {
  'use strict';
  if (window.__twfInit) return;
  window.__twfInit = true;

  function norm(s) { return String(s || '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function list(s) { return String(s || '').split(/[,\n]/).map(function (x) { return x.trim(); }).filter(Boolean); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function pieces(n) { return n + (n === 1 ? ' piece' : ' pieces'); }

  var root, drawer, CUR = '$', KEY = 'twf_all', SHOW_EMPTY = false, SB_KEY = 'meheraan_filters_sidebar';
  function sidebar() { return window.matchMedia('(min-width: 1000px)').matches; }
  function card() { return root ? (root.closest('.card') || root.parentElement) : null; }
  var GROUPS = {}, GROUP_KEYS = [];
  var SIZE_ORDER = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', '3xl', '4xl', '5xl', 'free size', 'one size'];
  var bounds = { lo: 0, hi: 1 }, sizeLabels = {}, sig = '', expanded = {}, gen = 0;
  // Accordion: every section starts closed; the shopper opens what they need. Remembered for the session,
  // and a section with an active selection opens by itself unless the shopper closed it.
  var openKeys = {}, closedKeys = {};
  try { openKeys = JSON.parse(sessionStorage.getItem('twf_open') || '{}') || {}; closedKeys = JSON.parse(sessionStorage.getItem('twf_closed') || '{}') || {}; } catch (e) {}
  function saveSections() { try { sessionStorage.setItem('twf_open', JSON.stringify(openKeys)); sessionStorage.setItem('twf_closed', JSON.stringify(closedKeys)); } catch (e) {} }
  function hasSelection(key) {
    if (key === 'size') return S.size.length > 0;
    if (key === 'price') return S.min !== null || S.max !== null;
    return !!(S.g[key] && S.g[key].length);
  }
  function applySections() {
    $$('.twf-s[data-twf-section]', root).forEach(function (sec) {
      var key = sec.getAttribute('data-twf-section');
      var o = closedKeys[key] ? false : (!!openKeys[key] || hasSelection(key));
      sec.classList.toggle('is-open', o);
      var h = sec.querySelector('.twf-h'); if (h) h.setAttribute('aria-expanded', String(o));
    });
  }
  function $(sel) { return root ? root.querySelector(sel) : null; }

  function blank() { return { g: {}, size: [], min: null, max: null, stock: false, sale: false, xt: [] }; }
  var S = blank();
  function sel(k) { if (!S.g[k]) S.g[k] = []; return S.g[k]; }
  function restore() {
    S = blank();
    try {
      var v = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (v && typeof v === 'object') {
        if (v.g && typeof v.g === 'object') GROUP_KEYS.forEach(function (k) { if (Array.isArray(v.g[k])) S.g[k] = v.g[k].slice(); });
        if (Array.isArray(v.size)) S.size = v.size.slice();
        if (typeof v.min === 'number') S.min = v.min;
        if (typeof v.max === 'number') S.max = v.max;
        S.stock = !!v.stock; S.sale = !!v.sale;
        if (Array.isArray(v.xt)) S.xt = v.xt.slice();
      }
    } catch (e) {}
  }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(S)); } catch (e) {} }

  function swatchColor(g, k, label) {
    if (g.swatches[k]) return g.swatches[k];
    if (k === 'multicolour' || k === 'multicolor' || k === 'multi') return 'conic-gradient(#E9A6BC,#F2C94C,#3E7C4F,#2E5AAC,#C8102E,#E9A6BC)';
    var name = label.replace(/\s+/g, '').toLowerCase();
    if (window.CSS && CSS.supports && CSS.supports('color', name)) return name;
    return '#D9D2D5';
  }

  function readGroups() {
    GROUPS = {}; GROUP_KEYS = [];
    $$('[data-twf-group]', root).forEach(function (sec) {
      var key = sec.getAttribute('data-twf-group'), map = {}, order = [];
      list(sec.getAttribute('data-twf-tags')).forEach(function (l) { var k = norm(l); if (k && !map[k]) { map[k] = l; order.push(k); } });
      var sw = {};
      list(sec.getAttribute('data-twf-swatches')).forEach(function (pair) {
        var i = pair.indexOf(':'); if (i < 1) return;
        var k = norm(pair.slice(0, i)), c = pair.slice(i + 1).trim(); if (k && c) sw[k] = c;
      });
      GROUPS[key] = { key: key, label: sec.getAttribute('data-twf-label') || key, style: sec.getAttribute('data-twf-style') || 'list',
        limit: parseInt(sec.getAttribute('data-twf-limit'), 10) || 6, map: map, order: order, swatches: sw };
      GROUP_KEYS.push(key);
    });
  }

  function cards() { return $$('.product-list--collection .product-item[data-tw-tags]'); }

  function parse(el) {
    if (el.__twf && el.__twf.v === sig + ':' + gen) return el.__twf;
    var tags = (el.getAttribute('data-tw-tags') || '').split('|').map(norm).filter(Boolean);
    var sizes = {};
    (el.getAttribute('data-tw-sizes') || '').split('|').forEach(function (p) {
      var i = p.lastIndexOf(':'); if (i < 1) return;
      var raw = p.slice(0, i).trim(), k = norm(raw), a = p.slice(i + 1) === '1';
      if (!k) return;
      sizes[k] = sizes[k] || a;
      if (!sizeLabels[k]) sizeLabels[k] = raw;
    });
    var g = {};
    GROUP_KEYS.forEach(function (key) { var out = []; tags.forEach(function (t) { if (GROUPS[key].map[t] && out.indexOf(t) < 0) out.push(t); }); g[key] = out; });
    el.__twf = { v: sig + ':' + gen, g: g, sizes: sizes, tags: tags,
      price: (parseInt(el.getAttribute('data-tw-price'), 10) || 0) / 100,
      sale: el.getAttribute('data-tw-sale') === '1',
      avail: el.getAttribute('data-tw-avail') === '1' };
    return el.__twf;
  }

  function has(arr, wanted) { return wanted.some(function (v) { return arr.indexOf(v) > -1; }); }
  function match(p, skip) {
    for (var i = 0; i < GROUP_KEYS.length; i++) {
      var k = GROUP_KEYS[i];
      if (skip !== k && S.g[k] && S.g[k].length && !has(p.g[k], S.g[k])) return false;
    }
    if (skip !== 'size' && S.size.length && !S.size.some(function (v) { return p.sizes[v]; })) return false;
    if (S.min !== null && p.price < S.min) return false;
    if (S.max !== null && p.price > S.max) return false;
    if (S.stock && !p.avail) return false;
    if (S.sale && !p.sale) return false;
    if (S.xt.length && !S.xt.every(function (t) { return p.tags.indexOf(t) > -1; })) return false;
    return true;
  }
  function activeCount() {
    var n = S.size.length + S.xt.length + (S.min !== null || S.max !== null ? 1 : 0) + (S.stock ? 1 : 0) + (S.sale ? 1 : 0);
    GROUP_KEYS.forEach(function (k) { n += (S.g[k] || []).length; });
    return n;
  }

  function rebound(ps) {
    var prices = ps.map(function (p) { return p.price; });
    bounds.lo = Math.floor(Math.min.apply(null, prices));
    bounds.hi = Math.ceil(Math.max.apply(null, prices));
    if (bounds.hi <= bounds.lo) bounds.hi = bounds.lo + 1;
    var mn = $('[data-twf-min]'), mx = $('[data-twf-max]');
    mn.min = mx.min = bounds.lo; mn.max = mx.max = bounds.hi; mn.step = mx.step = 1;
    GROUP_KEYS.forEach(function (k) { S.g[k] = (S.g[k] || []).filter(function (v) { return SHOW_EMPTY ? !!GROUPS[k].map[v] : ps.some(function (p) { return p.g[k].indexOf(v) > -1; }); }); });
    S.size = S.size.filter(function (v) { return ps.some(function (p) { return v in p.sizes; }); });
    if (S.min !== null && S.min <= bounds.lo) S.min = null;
    if (S.max !== null && S.max >= bounds.hi) S.max = null;
  }

  function optionHtml(g, k, n, on) {
    var zero = !n && !on ? ' is-zero' : '', label = g.map[k];
    if (g.style === 'chips') {
      return '<button type="button" class="twf-chip' + (on ? ' is-on' : '') + zero + '" data-twf-k="' + esc(g.key) + '" data-twf-v="' + esc(k) + '" aria-pressed="' + on + '">' + esc(label) + '<b>' + n + '</b></button>';
    }
    var dot = g.style === 'swatches' ? '<span class="twf-dot" style="background:' + esc(swatchColor(g, k, label)) + '"></span>' : '';
    return '<li><label class="twf-cb' + zero + '"><input type="checkbox" class="no-restyle" data-twf-k="' + esc(g.key) + '" value="' + esc(k) + '"' + (on ? ' checked' : '') +
      '><span class="twf-cb-box"></span>' + dot + '<span class="twf-cb-lab">' + esc(label) + '</span><span class="twf-ct">' + n + '</span></label></li>';
  }

  function renderLists(ps) {
    GROUP_KEYS.forEach(function (key) {
      var g = GROUPS[key];
      var present = SHOW_EMPTY ? g.order.slice() : g.order.filter(function (k) { return ps.some(function (p) { return p.g[key].indexOf(k) > -1; }); });
      var sec = $('[data-twf-section="' + key + '"]'), box = $('[data-twf-list="' + key + '"]');
      sec.hidden = !present.length;
      var chosen = S.g[key] || [];
      var open = expanded[key] || chosen.some(function (v) { return present.indexOf(v) >= g.limit; });
      var shown = open ? present : present.slice(0, g.limit);
      var items = shown.map(function (k) {
        var n = ps.filter(function (p) { return match(p, key) && p.g[key].indexOf(k) > -1; }).length;
        return optionHtml(g, k, n, chosen.indexOf(k) > -1);
      }).join('');
      var more = present.length > g.limit ? '<button type="button" class="twf-more" data-twf-more="' + esc(key) + '">' + (open ? 'Show less' : 'Show more (' + (present.length - g.limit) + ')') + '</button>' : '';
      box.innerHTML = (g.style === 'chips' ? '<div class="twf-chips">' + items + '</div>' : '<ul class="twf-list" role="list">' + items + '</ul>') + more;
    });

    var keys = {};
    ps.forEach(function (p) { for (var k in p.sizes) keys[k] = 1; });
    var sizes = Object.keys(keys).sort(function (a, b) {
      var ia = SIZE_ORDER.indexOf(a), ib = SIZE_ORDER.indexOf(b);
      if (ia < 0 && ib < 0) return a.localeCompare(b, undefined, { numeric: true });
      if (ia < 0) return 1; if (ib < 0) return -1; return ia - ib;
    });
    $('[data-twf-section="size"]').hidden = !sizes.length;
    $('[data-twf-list="size"]').innerHTML = sizes.map(function (k) {
      var n = ps.filter(function (p) { return match(p, 'size') && p.sizes[k]; }).length, on = S.size.indexOf(k) > -1;
      return '<button type="button" class="twf-size' + (on ? ' is-on' : '') + (!n && !on ? ' is-out' : '') + '" data-twf-k="size" data-twf-v="' + esc(k) +
        '" aria-pressed="' + on + '" title="' + (n ? n + ' in stock' : 'Sold out') + '">' + esc(sizeLabels[k] || k) + '</button>';
    }).join('');

    $('[data-twf-section="sale"]').hidden = !SHOW_EMPTY && !ps.some(function (p) { return p.sale; });
    $('[data-twf-section="price"]').hidden = bounds.hi - bounds.lo < 2;
    applySections();
  }

  function applyCards(cs, ps) {
    var n = 0;
    cs.forEach(function (c, i) { var ok = match(ps[i]); c.classList.toggle('twf-hide', !ok); if (ok) n++; });
    return n;
  }

  function pillsHtml() {
    var pills = [];
    S.xt.forEach(function (t) { pills.push(['xt', t, t.replace(/\b\w/g, function (c) { return c.toUpperCase(); })]); });
    GROUP_KEYS.forEach(function (key) {
      if (key === GROUP_KEYS[0]) { (S.g[key] || []).forEach(function (k) { pills.push([key, k, GROUPS[key].map[k]]); }); S.size.forEach(function (k) { pills.push(['size', k, 'Size ' + (sizeLabels[k] || k)]); }); }
      else (S.g[key] || []).forEach(function (k) { pills.push([key, k, GROUPS[key].map[k]]); });
    });
    if (!GROUP_KEYS.length) S.size.forEach(function (k) { pills.push(['size', k, 'Size ' + (sizeLabels[k] || k)]); });
    if (S.min !== null || S.max !== null) pills.push(['price', '', CUR + (S.min === null ? bounds.lo : S.min) + ' – ' + CUR + (S.max === null ? bounds.hi : S.max)]);
    if (S.stock) pills.push(['stock', '', 'In stock']);
    if (S.sale) pills.push(['sale', '', 'On sale']);
    return pills.map(function (p) {
      return '<span class="twf-pill">' + esc(p[2]) + '<button type="button" data-twf-rm="' + esc(p[0]) + '" data-twf-v="' + esc(p[1]) + '" aria-label="Remove ' + esc(p[2]) + '">×</button></span>';
    }).join('');
  }

  function updateUI(n, total) {
    var a = activeCount(), html = pillsHtml();

    $$('[data-twf-badge]').forEach(function (b) { b.textContent = a; b.hidden = !a; });
    $$('[data-twf-open]').forEach(function (b) { b.classList.toggle('has-active', a > 0); b.hidden = !total; });

    var view = $('[data-twf-view]');
    view.textContent = !a ? 'View all ' + pieces(total) : n ? 'View ' + pieces(n) : 'No pieces match';
    view.classList.toggle('is-empty', a > 0 && !n);

    $('[data-twf-applied]').innerHTML = html ? html + '<button type="button" class="twf-clear" data-twf-clear>Clear all</button>' : '';

    var tb = document.querySelector('.collection__toolbar'), recap = document.querySelector('.twf-recap');
    if (tb && a) {
      if (!recap) { recap = document.createElement('div'); recap.className = 'twf-recap'; tb.parentNode.insertBefore(recap, tb.nextSibling); }
      recap.innerHTML = '<div class="twf-recap-pills">' + html + '<button type="button" class="twf-clear" data-twf-clear>Clear all</button></div><span class="twf-recap-n">' + pieces(n) + '</span>';
    } else if (recap) { recap.parentNode.removeChild(recap); }

    var listEl = document.querySelector('.product-list--collection'), empty = document.querySelector('.twf-empty');
    if (listEl && a && !n) {
      if (!empty) { empty = document.createElement('div'); empty.className = 'twf-empty'; listEl.parentNode.insertBefore(empty, listEl.nextSibling); }
      empty.innerHTML = '<h3>No pieces match these filters</h3><p>Try removing one or two to see more of the collection.</p><button type="button" class="twf-clear" data-twf-clear>Clear all filters</button>';
    } else if (empty) { empty.parentNode.removeChild(empty); }

    var mn = $('[data-twf-min]'), mx = $('[data-twf-max]');
    var lo = S.min === null ? bounds.lo : S.min, hi = S.max === null ? bounds.hi : S.max;
    if (document.activeElement !== mn) mn.value = lo;
    if (document.activeElement !== mx) mx.value = hi;
    var span = bounds.hi - bounds.lo || 1, fill = $('[data-twf-fill]');
    fill.style.left = ((lo - bounds.lo) / span * 100) + '%';
    fill.style.width = ((hi - lo) / span * 100) + '%';
    $('[data-twf-minv]').textContent = CUR + lo;
    $('[data-twf-maxv]').textContent = CUR + hi;

    ['stock', 'sale'].forEach(function (k) { var b = $('[data-twf-switch="' + k + '"]'); b.classList.toggle('is-on', S[k]); b.setAttribute('aria-checked', String(S[k])); });
    syncButtons();
  }

  function refresh() {
    if (!root || !document.contains(root)) { init(); return; }
    var cs = cards();
    if (!cs.length) {
      root.hidden = true;
      $$('[data-twf-open]').forEach(function (b) { b.hidden = true; });
      var r = document.querySelector('.twf-recap'); if (r) r.parentNode.removeChild(r);
      return;
    }
    root.hidden = false;
    var s = cs.map(function (c) { return c.getAttribute('data-tw-handle'); }).join(',');
    var ps;
    if (s !== sig) { sig = s; ps = cs.map(parse); rebound(ps); } else { ps = cs.map(parse); }
    renderLists(ps);
    updateUI(applyCards(cs, ps), cs.length);
    save();
    syncUrl();
  }

  // Menu links such as /collections/kurta-sets?filter.p.tag=chikankari: Shopify ignores the tag (tag filtering is not
  // enabled on the store), so the drawer applies it. A tag that is one of a group's options ticks that option;
  // any other tag still narrows the grid and shows as a removable chip.
  function urlTags() { try { return new URL(location.href).searchParams.getAll('filter.p.tag').map(norm).filter(Boolean); } catch (e) { return []; } }
  function groupFor(t) {
    var hit = null;
    [t, t + 's', t.replace(/s$/, '')].some(function (c) { return GROUP_KEYS.some(function (k) { if (GROUPS[k].map[c]) { hit = [k, c]; return true; } return false; }); });
    return hit;
  }
  function applyUrlTags() {
    var ts = urlTags(); if (!ts.length) return;
    S = blank();
    ts.forEach(function (t) { var h = groupFor(t); if (h) { if (sel(h[0]).indexOf(h[1]) < 0) sel(h[0]).push(h[1]); } else if (S.xt.indexOf(t) < 0) S.xt.push(t); });
  }
  // Keep the address in step: drop filter.p.tag values the shopper has since removed.
  function syncUrl() {
    try {
      var u = new URL(location.href), vals = u.searchParams.getAll('filter.p.tag'); if (!vals.length) return;
      var keep = vals.filter(function (v) { var h = groupFor(norm(v)); return h ? (S.g[h[0]] || []).indexOf(h[1]) > -1 : S.xt.indexOf(norm(v)) > -1; });
      if (keep.length === vals.length) return;
      u.searchParams.delete('filter.p.tag'); keep.forEach(function (v) { u.searchParams.append('filter.p.tag', v); });
      history.replaceState(history.state, '', u.pathname + (u.search ? u.search : '') + u.hash);
    } catch (e) {}
  }

  function isOpen() {
    if (!root) return false;
    return sidebar() ? !card().classList.contains('twf-collapsed') : root.classList.contains('is-open');
  }
  function syncButtons() {
    var o = isOpen(), sb = sidebar();
    $$('[data-twf-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(o)); b.classList.toggle('is-open', sb && o); });
  }
  // Desktop (>=1000px): the drawer is a permanent sidebar column beside the grid — it never closes.
  // Smaller screens: slide-in overlay drawer opened by the Filter button.
  function open(o) {
    if (!root) return;
    if (sidebar()) {
      card().classList.remove('twf-collapsed');
      root.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.remove('twf-lock');
    } else {
      root.classList.toggle('is-open', o);
      drawer.setAttribute('aria-hidden', String(!o));
      document.documentElement.classList.toggle('twf-lock', o);
      if (o) { var x = $('.twf-x'); if (x) x.focus(); }
    }
    syncButtons();
  }
  function applyMode() {
    if (!root) return;
    if (sidebar()) {
      root.classList.remove('is-open');
      document.documentElement.classList.remove('twf-lock');
      drawer.setAttribute('aria-hidden', 'false');
      card().classList.remove('twf-collapsed');
      try { localStorage.removeItem(SB_KEY); } catch (e) {}
    } else {
      card().classList.remove('twf-collapsed');
      drawer.setAttribute('aria-hidden', String(!root.classList.contains('is-open')));
    }
    syncButtons();
  }

  function toggle(k, v) {
    var arr = k === 'size' ? S.size : sel(k);
    var i = arr.indexOf(v);
    if (i > -1) arr.splice(i, 1); else arr.push(v);
    refresh();
  }

  function init() {
    root = document.querySelector('[data-twf]');
    if (!root) return;
    drawer = root.querySelector('.twf-dr');
    CUR = root.getAttribute('data-twf-currency') || '$';
    KEY = 'twf_' + (root.getAttribute('data-twf-handle') || 'all');
    SHOW_EMPTY = root.getAttribute('data-twf-show-empty') === '1';
    readGroups();
    restore();
    applyUrlTags();
    gen++; sig = ''; expanded = {};
    applyMode();
    refresh();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button, [data-twf-close]') : null;
    if (!t) return;
    if (t.hasAttribute('data-twf-open')) { e.preventDefault(); open(true); return; }
    if (t.hasAttribute('data-twf-close')) { e.preventDefault(); open(false); return; }
    if (t.hasAttribute('data-twf-clear')) { e.preventDefault(); S = blank(); refresh(); return; }
    if (t.hasAttribute('data-twf-toggle-section')) {
      var sec = t.closest('.twf-s'), sk = sec.getAttribute('data-twf-section');
      if (sec.classList.contains('is-open')) { closedKeys[sk] = 1; delete openKeys[sk]; } else { openKeys[sk] = 1; delete closedKeys[sk]; }
      saveSections(); applySections(); return;
    }
    if (t.hasAttribute('data-twf-more')) { var mk = t.getAttribute('data-twf-more'); expanded[mk] = !expanded[mk]; refresh(); return; }
    if (t.hasAttribute('data-twf-switch')) { var k = t.getAttribute('data-twf-switch'); S[k] = !S[k]; refresh(); return; }
    if (t.hasAttribute('data-twf-rm')) {
      var rk = t.getAttribute('data-twf-rm'), rv = t.getAttribute('data-twf-v');
      if (rk === 'price') { S.min = null; S.max = null; }
      else if (rk === 'stock' || rk === 'sale') { S[rk] = false; }
      else if (rk === 'xt') { var xi = S.xt.indexOf(rv); if (xi > -1) S.xt.splice(xi, 1); }
      else { var arr = rk === 'size' ? S.size : sel(rk); var j = arr.indexOf(rv); if (j > -1) arr.splice(j, 1); }
      refresh(); return;
    }
    if (t.hasAttribute('data-twf-k') && t.hasAttribute('data-twf-v')) { toggle(t.getAttribute('data-twf-k'), t.getAttribute('data-twf-v')); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('input[type="checkbox"][data-twf-k]')) toggle(t.getAttribute('data-twf-k'), t.value);
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.hasAttribute || !(t.hasAttribute('data-twf-min') || t.hasAttribute('data-twf-max'))) return;
    var mn = $('[data-twf-min]'), mx = $('[data-twf-max]');
    var a = +mn.value, b = +mx.value;
    if (a > b - 1) { if (t === mn) { a = b - 1; mn.value = a; } else { b = a + 1; mx.value = b; } }
    S.min = a <= bounds.lo ? null : a;
    S.max = b >= bounds.hi ? null : b;
    refresh();
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && !sidebar() && root.classList.contains('is-open')) open(false); });
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(applyMode, 120); });

  // The theme re-renders the toolbar and product list on sort/page-size changes: re-apply when the cards change
  var raf = 0;
  function check() {
    if (!root || !document.contains(root)) { init(); return; }
    var cs = cards();
    var s = cs.map(function (c) { return c.getAttribute('data-tw-handle'); }).join(',');
    var a = activeCount(), badge = document.querySelector('[data-twf-badge]');
    var stale = s !== sig || (badge && badge.hidden !== !a) || (a > 0 && cs.length && !document.querySelector('.twf-recap'));
    if (stale) refresh();
  }
  new MutationObserver(function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; check(); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', function () { init(); });
  // Theme editor: selecting a filter-group block opens the drawer so the merchant can see it
  document.addEventListener('shopify:block:select', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-twf-group')) { open(true); } });

  init();
})();
